import React, { FC, createContext, ReactElement } from 'react';
import { Segments } from 'Common/types/segments';

export interface SegmentsProps {
    value: Segments;
}

export const SegmentsContext = createContext<Segments>({} as Segments);
const { Provider, Consumer } = SegmentsContext;
export { Consumer as SegmentsConsumer };

export const SegmentsProvider: FC<SegmentsProps> = ({ children, value }): ReactElement => (
    <Provider value={value}>{children}</Provider>
);
